/* PHD Minerals · interactive layer (vanilla JS, no dependencies) */
(function () {
  'use strict';

  var CFG = window.PHD || {};
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- helpers ---------- */
  function money(cents) {
    var fmt = (window.theme && theme.moneyFormat) || '${{amount}}';
    cents = Number(cents) || 0;
    function f(n, d, ts, ds) {
      var parts = (n / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return f(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return f(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return f(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return f(cents, 2, "'", '.');
        default: return f(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  function sized(url, w) {
    if (!url) return '';
    url = url.indexOf('//') === 0 ? 'https:' + url : url;
    return url.replace(/(_\d+x\d*)?(\.(jpe?g|png|gif|webp|heic))(\?|$)/i, '_' + w + 'x$2$4');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function list(s) { return String(s || '').toLowerCase().split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }

  /* parse a product (title + tags) into a specimen label — mirrors snippets/phd-specimen-data.liquid */
  function specimen(title, tags) {
    var out = { mineral: title, no: '', locality: '', place: '', colors: [], assoc: [] };
    var m = /^(.*)-\s*(\d+)\s*$/.exec(title || '');
    if (m && Number(m[2]) > 0) { out.mineral = m[1].trim(); out.no = m[2]; }
    var colors = list(CFG.colorTags), countries = list(CFG.countryTags), hidden = list(CFG.hiddenTags), words = list(CFG.localityWords);
    (tags || []).forEach(function (t) {
      var k = t.toLowerCase().trim();
      if (colors.indexOf(k) > -1) { out.colors.push(t); return; }
      if (countries.indexOf(k) > -1) { if (!out.place || out.place === 'Canada') out.place = t; return; }
      if (words.some(function (w) { return k.indexOf(w) > -1; })) { out.locality = out.locality ? out.locality + ', ' + t : t; return; }
      if (hidden.indexOf(k) > -1 || k === out.mineral.toLowerCase()) return;
      out.assoc.push(t);
    });
    out.where = [out.locality, out.place].filter(Boolean).join(' · ');
    return out;
  }
  function labelCard(s) {
    var rows = [['Mineral', s.mineral], ['Locality', s.locality], ['Region', s.place], ['Associated', s.assoc.join(', ')], ['Colour', s.colors.join(', ')]];
    return '<div class="phd-labelcard"><div class="phd-labelcard__head"><span>PHD Minerals · Specimen label</span><span>' + (s.no ? 'No. ' + esc(s.no) : '') + '</span></div><dl>' +
      rows.filter(function (r) { return r[1]; }).map(function (r) { return '<div><dt>' + r[0] + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('') + '</dl></div>';
  }

  /* ---------- cart ---------- */
  function addToCart(id, qty) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        $$('[data-cart-count-bubble]').forEach(function (el) { el.classList.remove('hide'); });
        return cart;
      });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = $$('[data-phd-reveal]');
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- header state ---------- */
  function initHeader() {
    var on = false;
    function tick() { var s = window.scrollY > 24; if (s !== on) { on = s; document.documentElement.classList.toggle('is-scrolled', s); } }
    window.addEventListener('scroll', tick, { passive: true }); tick();
    var hdr = $('#shopify-section-header') || $('[data-header-section]');
    function measure() { if (hdr && hdr.offsetHeight) document.documentElement.style.setProperty('--header-h', hdr.offsetHeight + 'px'); }
    measure(); window.addEventListener('resize', measure);
  }

  /* ---------- count up ---------- */
  function initCounters() {
    var els = $$('[data-phd-count]');
    if (!els.length || reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target, end = Number(el.getAttribute('data-phd-count')) || 0, t0 = performance.now(), d = 1600;
        el.textContent = '0';
        (function step(t) { var p = Math.min(1, (t - t0) / d); el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(step); })(t0);
      });
    }, { threshold: .3 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- hero: light + sparkles ---------- */
  function initHero() {
    var hero = $('[data-phd-hero]');
    if (!hero) return;
    var vid = $('video', hero);
    if (vid) {
      var saver = navigator.connection && navigator.connection.saveData;
      if (saver || reduceMotion) { vid.pause(); vid.removeAttribute('autoplay'); }
      else { vid.muted = true; var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
    }
    if (finePointer && !reduceMotion) {
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        hero.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    }
    var cv = $('[data-phd-sparkle]', hero);
    if (!cv || reduceMotion) return;
    var ctx = cv.getContext('2d'), stars = [], W = 0, H = 0, dpr = Math.min(2, window.devicePixelRatio || 1), running = false, raf;
    function size() { W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    function spawn() { return { x: Math.random() * W, y: Math.random() * H * .9, r: 1.5 + Math.random() * 4.5, life: 0, max: 90 + Math.random() * 140, hue: [42, 270, 180, 330][Math.floor(Math.random() * 4)] }; }
    function star(s) {
      var k = Math.max(0, Math.sin(Math.PI * s.life / s.max)), r = s.r * k + .01;
      ctx.save(); ctx.translate(s.x, s.y); ctx.globalAlpha = k * .85;
      var g = ctx.createRadialGradient(0, 0, 0, 0, 0, r * 4); g.addColorStop(0, 'hsla(' + s.hue + ',90%,85%,.55)'); g.addColorStop(1, 'hsla(' + s.hue + ',90%,85%,0)');
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(0, 0, r * 4, 0, 7); ctx.fill();
      ctx.fillStyle = '#fff'; ctx.beginPath();
      ctx.moveTo(0, -r * 2.2); ctx.quadraticCurveTo(0, 0, r * 2.2, 0); ctx.quadraticCurveTo(0, 0, 0, r * 2.2); ctx.quadraticCurveTo(0, 0, -r * 2.2, 0); ctx.quadraticCurveTo(0, 0, 0, -r * 2.2);
      ctx.fill(); ctx.restore();
    }
    function frame() {
      ctx.clearRect(0, 0, W, H);
      if (stars.length < Math.max(8, Math.round(W / 90)) && Math.random() < .08) stars.push(spawn());
      stars = stars.filter(function (s) { s.life++; star(s); return s.life < s.max; });
      raf = requestAnimationFrame(frame);
    }
    size(); window.addEventListener('resize', size);
    new IntersectionObserver(function (en) {
      if (en[0].isIntersecting && !running) { running = true; frame(); }
      else if (!en[0].isIntersecting && running) { running = false; cancelAnimationFrame(raf); }
    }).observe(hero);
  }

  /* ---------- tilt + glare ---------- */
  function initTilt() {
    if (!finePointer || reduceMotion || CFG.tilt === false) return;
    document.addEventListener('pointermove', function (e) {
      var media = e.target.closest && e.target.closest('.phd-card__frame, [data-phd-tilt]');
      if (!media) return;
      var el = media.classList.contains('phd-card__frame') ? media.querySelector('.phd-card__media') : media;
      var r = media.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      el.style.setProperty('--ry', ((x - .5) * 10).toFixed(2) + 'deg');
      el.style.setProperty('--rx', ((.5 - y) * 10).toFixed(2) + 'deg');
      el.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
      el.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      if (el.hasAttribute('data-phd-tilt')) el.style.transform = 'perspective(900px) rotateX(' + ((.5 - y) * 8).toFixed(2) + 'deg) rotateY(' + ((x - .5) * 8).toFixed(2) + 'deg)';
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var media = e.target.closest && e.target.closest('.phd-card__frame, [data-phd-tilt]');
      if (!media || media.contains(e.relatedTarget)) return;
      var el = media.classList.contains('phd-card__frame') ? media.querySelector('.phd-card__media') : media;
      el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg');
      if (el.hasAttribute('data-phd-tilt')) el.style.transform = '';
    });
  }

  /* ---------- cursor spotlight on cards ---------- */
  function initSpots() {
    if (!finePointer) return;
    $$('[data-phd-spot]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--sx', (e.clientX - r.left) + 'px'); el.style.setProperty('--sy', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ---------- loupe magnifier ---------- */
  function attachLoupe(host, getImg) {
    if (!finePointer || CFG.loupe === false || host.__loupe) return;
    host.__loupe = true;
    var lens = host.querySelector('.phd-loupe');
    if (!lens) { lens = document.createElement('span'); lens.className = 'phd-loupe'; host.appendChild(lens); }
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var Z = 2.6;
    function src(img) { return img.getAttribute('data-zoom') || sized(img.currentSrc || img.src, 2048); }
    host.addEventListener('pointerenter', function () { var img = getImg(); if (!img) return; lens.style.backgroundImage = 'url("' + src(img) + '")'; lens.classList.add('is-on'); });
    host.addEventListener('pointerleave', function () { lens.classList.remove('is-on'); });
    host.addEventListener('pointermove', function (e) {
      var img = getImg(); if (!img) return;
      var hr = host.getBoundingClientRect(), ir = img.getBoundingClientRect();
      var x = e.clientX - ir.left, y = e.clientY - ir.top;
      if (x < 0 || y < 0 || x > ir.width || y > ir.height) { lens.classList.remove('is-on'); return; }
      lens.classList.add('is-on');
      lens.style.left = (e.clientX - hr.left) + 'px'; lens.style.top = (e.clientY - hr.top) + 'px';
      // account for object-fit: cover
      var nw = img.naturalWidth || ir.width, nh = img.naturalHeight || ir.height;
      var scale = Math.max(ir.width / nw, ir.height / nh), dw = nw * scale, dh = nh * scale;
      var ox = (dw - ir.width) / 2, oy = (dh - ir.height) / 2;
      if (getComputedStyle(img).objectFit === 'contain') { scale = Math.min(ir.width / nw, ir.height / nh); dw = nw * scale; dh = nh * scale; ox = (dw - ir.width) / 2; oy = (dh - ir.height) / 2; }
      lens.style.backgroundSize = (dw * Z) + 'px ' + (dh * Z) + 'px';
      lens.style.backgroundPosition = (-(x + ox) * Z + lens.offsetWidth / 2) + 'px ' + (-(y + oy) * Z + lens.offsetHeight / 2) + 'px';
    });
  }
  function initLoupes() {
    $$('[data-phd-loupe-host]').forEach(function (host) { attachLoupe(host, function () { return host.querySelector('img.is-active') || host.querySelector('img'); }); });
    // Debut product page media
    $$('.template-product .product-single__media-wrapper').forEach(function (w) {
      w.setAttribute('data-phd-loupe-host', '');
      attachLoupe(w, function () { return w.querySelector('img.feature-row__image, img.product-featured-media, img'); });
    });
  }

  /* ---------- thumbnails (spotlight + quick view) ---------- */
  function wireThumbs(scope) {
    var thumbs = $$('.phd-thumb', scope);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-index');
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); });
        $$('[data-index]', scope).forEach(function (img) { if (img.tagName === 'IMG') img.classList.toggle('is-active', img.getAttribute('data-index') === i); });
      });
    });
  }

  /* ---------- ajax add (spotlight form) ---------- */
  function initAjaxForms() {
    $$('[data-phd-ajax-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type=submit]'), label = btn.textContent;
        btn.disabled = true; btn.textContent = 'Adding…';
        addToCart(form.querySelector('[name=id]').value, 1).then(function () {
          btn.textContent = 'Added ✓ — view cart';
          btn.disabled = false;
          form.onsubmit = null;
          btn.addEventListener('click', function (ev) { ev.preventDefault(); window.location.href = ROOT + 'cart'; }, { once: true });
        }).catch(function (err) { btn.disabled = false; btn.textContent = (err && err.description) || label; });
      });
    });
  }

  /* ---------- modal shell ---------- */
  var lastFocus = null;
  function openModal(inner, cls) {
    closeModal();
    lastFocus = document.activeElement;
    var m = document.createElement('div');
    m.className = 'phd-modal ' + (cls || '');
    m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true');
    m.innerHTML = '<button type="button" class="phd-round phd-modal__close" aria-label="Close" data-modal-close><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.6"/></svg></button>' + inner;
    document.body.appendChild(m);
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { m.classList.add('is-open'); });
    m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('[data-modal-close]')) closeModal(); });
    m.querySelector('[data-modal-close]').focus();
    return m;
  }
  function closeModal() {
    var m = $('.phd-modal'); if (!m) return;
    $$('video', m).forEach(function (v) { v.pause(); });
    m.remove(); document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    var m = $('.phd-modal'); if (!m) return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'Tab') {
      var f = $$('a[href], button:not([disabled]), input, select, video[controls]', m).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ---------- quick view ---------- */
  function initQuickView() {
    if (CFG.quickview === false) return;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-phd-quickview]');
      if (!b) return;
      e.preventDefault();
      quickView(b.getAttribute('data-phd-quickview'));
    });
  }
  function quickView(handle) {
    var m = openModal('<div class="phd-qv" aria-label="Quick look"><div class="phd-qv__skeleton">Polishing the glass…</div></div>', 'phd-modal--qv');
    fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js').then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (p) {
      var s = specimen(p.title, p.tags), v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
      var imgs = (p.images || []).slice(0, 8);
      var desc = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      var html = '<div class="phd-qv__media"><div class="phd-qv__main" data-phd-loupe-host>' +
        imgs.map(function (src, i) { return '<img data-index="' + i + '" class="' + (i ? '' : 'is-active') + '" style="' + (i ? 'opacity:0' : '') + '" src="' + sized(src, 900) + '" data-zoom="' + sized(src, 2048) + '" alt="' + esc(p.title) + (i ? ' — view ' + (i + 1) : '') + '">'; }).join('') +
        '<span class="phd-loupe" aria-hidden="true"></span></div>' +
        (imgs.length > 1 ? '<div class="phd-thumbs">' + imgs.map(function (src, i) { return '<button type="button" class="phd-thumb' + (i ? '' : ' is-active') + '" data-index="' + i + '" aria-label="View ' + (i + 1) + '"><img src="' + sized(src, 160) + '" alt=""></button>'; }).join('') + '</div>' : '') +
        '</div><div class="phd-qv__info"><p class="phd-eyebrow">' + (s.no ? 'Specimen No. ' + esc(s.no) : 'Individual specimen') + '</p><h2>' + esc(s.mineral) + '</h2>' +
        (s.where ? '<p style="margin:0;color:var(--mute)">' + esc(s.where) + '</p>' : '') +
        '<p class="phd-qv__price">' + (v && v.available ? money(v.price) : 'Sold') + '</p>' + labelCard(s) +
        (desc ? '<p class="phd-qv__desc">' + esc(desc) + '</p>' : '<div style="height:20px"></div>') +
        '<div class="phd-qv__actions">' + (v && v.available ? '<button type="button" class="phd-btn" data-qv-add="' + v.id + '">Add to cart</button>' : '') +
        '<a class="phd-link" href="' + ROOT.replace(/\/$/, '') + '/products/' + esc(p.handle) + '">Full details →</a></div><p class="phd-qv__status" role="status" aria-live="polite"></p></div>';
      var box = $('.phd-qv', m); if (!box) return;
      box.innerHTML = html;
      // image switching uses opacity inline so it works without spotlight CSS
      $$('.phd-thumb', box).forEach(function (t) {
        t.addEventListener('click', function () {
          var i = t.getAttribute('data-index');
          $$('.phd-thumb', box).forEach(function (x) { x.classList.toggle('is-active', x === t); });
          $$('.phd-qv__main img', box).forEach(function (img) { var on = img.getAttribute('data-index') === i; img.classList.toggle('is-active', on); img.style.opacity = on ? '' : '0'; });
        });
      });
      attachLoupe($('.phd-qv__main', box), function () { return $('.phd-qv__main img.is-active', box); });
      var add = $('[data-qv-add]', box);
      if (add) add.addEventListener('click', function () {
        var st = $('.phd-qv__status', box);
        add.disabled = true; add.textContent = 'Adding…';
        addToCart(add.getAttribute('data-qv-add'), 1).then(function () {
          add.outerHTML = '<a class="phd-btn" href="' + ROOT + 'cart">View cart & checkout</a>';
          st.textContent = 'Added to your cart. One of a kind — once it sells, it\'s gone.';
        }).catch(function (err) { add.disabled = false; add.textContent = 'Add to cart'; st.style.color = '#ffb4a8'; st.textContent = (err && err.description) || 'Could not add — it may already be in your cart.'; });
      });
    }).catch(function () { window.location.href = ROOT + 'products/' + handle; });
  }

  /* ---------- explorer ---------- */
  function initExplorer() {
    $$('[data-phd-explorer]').forEach(function (root) {
      var grid = $('[data-phd-grid]', root), cards = $$('[data-phd-card]', grid);
      if (!cards.length) return;
      var pageSize = Number(root.getAttribute('data-page-size')) || 12;
      var state = { q: '', origin: 'all', colors: [], price: [0, 0], mineral: '', sort: 'featured', sold: root.getAttribute('data-show-sold') === 'true', limit: pageSize };
      var countEl = $('[data-filter-count]', root), more = $('[data-filter-more]', root), empty = $('[data-filter-empty]', root);
      cards.forEach(function (c, i) { c.__i = i; });

      // build colour swatches + mineral chips from the cards themselves
      var colorCount = {}, minCount = {};
      cards.forEach(function (c) {
        (c.getAttribute('data-colors') || '').split(' ').filter(Boolean).forEach(function (k) { colorCount[k] = (colorCount[k] || 0) + 1; });
        var mn = c.getAttribute('data-mineral'); minCount[mn] = (minCount[mn] || 0) + 1;
      });
      var sw = $('[data-filter-colors]', root);
      Object.keys(colorCount).sort(function (a, b) { return colorCount[b] - colorCount[a]; }).forEach(function (k) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('data-color', k); b.setAttribute('aria-pressed', 'false');
        var name = k.charAt(0).toUpperCase() + k.slice(1);
        b.setAttribute('data-tip', name + ' · ' + colorCount[k]); b.setAttribute('aria-label', name);
        b.innerHTML = '<i class="sw sw-' + k + '"></i>'; sw.appendChild(b);
      });
      if (!sw.children.length) { sw.previousElementSibling && (sw.previousElementSibling.hidden = true); sw.hidden = true; }
      var mc = $('[data-filter-minerals]', root);
      var all = document.createElement('button'); all.type = 'button'; all.className = 'is-on'; all.setAttribute('data-mineral', ''); all.textContent = 'All minerals'; mc.appendChild(all);
      Object.keys(minCount).sort(function (a, b) { return minCount[b] - minCount[a] || a.localeCompare(b); }).forEach(function (k) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('data-mineral', k);
        b.innerHTML = esc(k) + '<small>' + minCount[k] + '</small>'; mc.appendChild(b);
      });

      function setOn(group, btn) { $$('button', group).forEach(function (x) { var on = x === btn; x.classList.toggle('is-on', on); if (x.hasAttribute('aria-pressed')) x.setAttribute('aria-pressed', on); }); }

      function apply(animate) {
        var shown = 0, matched = [];
        cards.forEach(function (c) {
          var price = Number(c.getAttribute('data-price')) / 100, avail = c.getAttribute('data-available') === 'true';
          var ok = (state.sold || avail) &&
            (state.origin === 'all' || c.getAttribute('data-origin') === state.origin) &&
            (!state.mineral || c.getAttribute('data-mineral') === state.mineral) &&
            (!state.colors.length || state.colors.some(function (k) { return (' ' + c.getAttribute('data-colors') + ' ').indexOf(' ' + k + ' ') > -1; })) &&
            (!state.q || state.q.split(/\s+/).every(function (w) { return c.getAttribute('data-search').indexOf(w) > -1; })) &&
            (!state.price[0] || price >= state.price[0]) && (!state.price[1] || (avail && price < state.price[1]));
          if (ok) matched.push(c);
        });
        var sorted = matched.slice().sort(function (a, b) {
          var aa = a.getAttribute('data-available') === 'true', ba = b.getAttribute('data-available') === 'true';
          if (aa !== ba) return aa ? -1 : 1;
          if (state.sort === 'price-asc') return a.getAttribute('data-price') - b.getAttribute('data-price');
          if (state.sort === 'price-desc') return b.getAttribute('data-price') - a.getAttribute('data-price');
          if (state.sort === 'new') return b.getAttribute('data-date') - a.getAttribute('data-date');
          return a.__i - b.__i;
        });
        cards.forEach(function (c) { c.classList.add('is-hidden'); });
        sorted.forEach(function (c, i) {
          grid.appendChild(c);
          if (i < state.limit) {
            var was = c.classList.contains('is-hidden');
            c.classList.remove('is-hidden'); shown++;
            if (animate && was && !reduceMotion) { c.classList.add('is-entering'); setTimeout(function () { c.classList.remove('is-entering'); }, 20 + Math.min(i, 12) * 35); }
          }
        });
        var avail = sorted.filter(function (c) { return c.getAttribute('data-available') === 'true'; }).length;
        countEl.innerHTML = 'Showing <b>' + shown + '</b> of <b>' + sorted.length + '</b> · ' + avail + ' available';
        more.hidden = sorted.length <= state.limit;
        empty.hidden = sorted.length > 0;
        var dirty = state.q || state.origin !== 'all' || state.colors.length || state.mineral || state.price[0] || state.price[1];
        $$('[data-filter-reset]', root).forEach(function (r) { if (!r.closest('[data-filter-empty]')) r.hidden = !dirty; });
        $$('[data-mineral]', mc).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-mineral') === state.mineral); });
        var n = (state.origin !== 'all' ? 1 : 0) + state.colors.length + (state.mineral ? 1 : 0) + (state.price[0] || state.price[1] ? 1 : 0);
        var badge = $('[data-filter-badge]', root); if (badge) badge.textContent = n ? n : '';
      }

      var tog = $('[data-filter-toggle]', root);
      if (tog) tog.addEventListener('click', function () { var f = $('[data-phd-filters]', root), on = !f.classList.contains('is-open'); f.classList.toggle('is-open', on); tog.setAttribute('aria-expanded', on); });
      var t;
      $('[data-filter-search]', root).addEventListener('input', function (e) { clearTimeout(t); t = setTimeout(function () { state.q = e.target.value.trim().toLowerCase(); state.limit = pageSize; apply(true); }, 140); });
      $$('[data-filter-origin]', root).forEach(function (b) { b.addEventListener('click', function () { state.origin = b.getAttribute('data-filter-origin'); setOn(b.parentNode, b); state.limit = pageSize; apply(true); }); });
      $$('[data-filter-price]', root).forEach(function (b) { b.addEventListener('click', function () { state.price = b.getAttribute('data-filter-price').split('-').map(Number); setOn(b.parentNode, b); state.limit = pageSize; apply(true); }); });
      sw.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        var k = b.getAttribute('data-color'), i = state.colors.indexOf(k);
        if (i > -1) state.colors.splice(i, 1); else state.colors.push(k);
        b.classList.toggle('is-on', i < 0); b.setAttribute('aria-pressed', i < 0); state.limit = pageSize; apply(true);
      });
      mc.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; state.mineral = b.getAttribute('data-mineral'); state.limit = pageSize; apply(true); });
      $('[data-filter-sort]', root).addEventListener('change', function (e) { state.sort = e.target.value; apply(true); });
      $('[data-filter-sold]', root).addEventListener('change', function (e) { state.sold = e.target.checked; apply(true); });
      more.addEventListener('click', function () { state.limit += pageSize; apply(true); });
      $$('[data-filter-reset]', root).forEach(function (r) {
        r.addEventListener('click', function () {
          state = { q: '', origin: 'all', colors: [], price: [0, 0], mineral: '', sort: state.sort, sold: state.sold, limit: pageSize };
          $('[data-filter-search]', root).value = '';
          setOn($('[data-filter-origin]', root).parentNode, $('[data-filter-origin="all"]', root));
          setOn($('[data-filter-price]', root).parentNode, $('[data-filter-price="0-0"]', root));
          $$('button', sw).forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
          apply(true);
        });
      });
      apply(false);
    });
  }

  /* ---------- video reel ---------- */
  function initReel() {
    $$('[data-phd-reel]').forEach(function (root) {
      var track = $('[data-reel-track]', root), vids = $$('video', track);
      if ('IntersectionObserver' in window && !reduceMotion) {
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (x) {
            var v = x.target;
            if (x.isIntersecting) { v.preload = 'auto'; v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
          });
        }, { threshold: .35 });
        vids.forEach(function (v) { v.muted = true; v.removeAttribute('controls'); io.observe(v); });
      }
      function step(dir) { var item = $('.phd-reel__item', track); track.scrollBy({ left: dir * ((item ? item.offsetWidth : 300) + 18), behavior: 'smooth' }); }
      var prev = $('[data-reel-prev]', root), next = $('[data-reel-next]', root);
      prev && prev.addEventListener('click', function () { step(-1); });
      next && next.addEventListener('click', function () { step(1); });
      // drag to scroll (mouse)
      var down = false, sx = 0, sl = 0, moved = false;
      track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
      window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-drag'); } track.scrollLeft = sl - dx; });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { track.classList.remove('is-drag'); }, 0); });
      $$('[data-reel-open]', track).forEach(function (b) {
        b.addEventListener('click', function (e) {
          if (moved) { e.preventDefault(); moved = false; return; }
          var v = $('video', b);
          if (!v) return;
          var sources = $$('source', v).map(function (s) { return '<source src="' + s.src + '" type="' + (s.type || '') + '">'; }).join('');
          var m = openModal('<video controls autoplay playsinline loop poster="' + (v.getAttribute('poster') || '') + '">' + sources + '</video>', 'phd-modal--video');
          var mv = $('video', m); mv.muted = false; var p = mv.play(); if (p && p.catch) p.catch(function () { mv.muted = true; mv.play(); });
        });
      });
    });
  }

  /* ---------- localities ---------- */
  function initLocalities() {
    $$('[data-phd-localities]').forEach(function (root) {
      var items = $$('.phd-loc', root), frame = $('[data-loc-frame]', root), cap = $('[data-loc-caption]', root), cur = -1;
      function show(i) {
        if (i === cur) return; cur = i;
        items.forEach(function (li, j) { li.classList.toggle('is-active', j === i); });
        var tpl = $('template[data-loc-img]', items[i]), blurb = $('.phd-loc__blurb', items[i]);
        if (frame) { frame.innerHTML = tpl ? tpl.innerHTML : ''; }
        if (cap) cap.textContent = blurb ? blurb.textContent : '';
      }
      items.forEach(function (li, i) {
        var a = $('a', li);
        a.addEventListener('mouseenter', function () { show(i); });
        a.addEventListener('focus', function () { show(i); });
        // on touch: first tap previews, second tap navigates
        a.addEventListener('click', function (e) { if (!finePointer && cur !== i) { e.preventDefault(); show(i); } });
      });
      show(0);
    });
  }

  /* ---------- field guide ---------- */
  function initGuide() {
    $$('[data-phd-guide]').forEach(function (root) {
      var cards = $$('[data-guide-card]', root), dots = $$('.phd-mohs__dot', root);
      dots.slice().sort(function (a, b) { return parseFloat(a.style.getPropertyValue('--x')) - parseFloat(b.style.getPropertyValue('--x')); })
        .forEach(function (d, i) { d.classList.add(i % 2 ? 'is-below' : 'is-above'); });
      cards.forEach(function (c, i) {
        var btn = $('.phd-flip__inner', c);
        btn.addEventListener('click', function () { var on = !c.classList.contains('is-flipped'); c.classList.toggle('is-flipped', on); btn.setAttribute('aria-expanded', on); });
        c.addEventListener('mouseenter', function () { dots.forEach(function (d) { d.classList.toggle('is-on', d.getAttribute('data-guide-target') === String(i)); }); });
        c.addEventListener('mouseleave', function () { dots.forEach(function (d) { d.classList.remove('is-on'); }); });
      });
      function mark(i) { dots.forEach(function (d) { d.classList.toggle('is-on', d.getAttribute('data-guide-target') === String(i)); }); }
      var grid = $('.phd-guide__grid', root);
      if (grid) grid.addEventListener('scroll', function () {
        if (grid.scrollWidth <= grid.clientWidth) return;
        var mid = grid.getBoundingClientRect().left + grid.clientWidth / 2, best = 0, bd = 1e9;
        cards.forEach(function (c, i) { var r = c.getBoundingClientRect(), dd = Math.abs(r.left + r.width / 2 - mid); if (dd < bd) { bd = dd; best = i; } });
        mark(best);
      }, { passive: true });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var c = cards[Number(d.getAttribute('data-guide-target'))]; if (!c) return;
          mark(d.getAttribute('data-guide-target'));
          c.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center', inline: 'center' });
          setTimeout(function () { c.classList.add('is-flipped'); $('.phd-flip__inner', c).setAttribute('aria-expanded', 'true'); }, reduceMotion ? 0 : 500);
        });
      });
      // a gentle nudge so visitors discover the cards flip
      if (!reduceMotion && cards[0] && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); setTimeout(function () { cards[0].classList.add('is-pulse'); }, 600); } }, { threshold: .6 });
        io.observe(cards[0]);
      }
    });
  }

  /* ---------- recently viewed ---------- */
  var RKEY = 'phd:recent';
  function initRecent() {
    if (CFG.recent === false) return;
    var cur = $('[data-phd-recent-item]'), list = store(RKEY) || [], currentHandle = null;
    if (cur) {
      try {
        var item = JSON.parse(cur.textContent); currentHandle = item.handle;
        list = [item].concat(list.filter(function (x) { return x.handle !== item.handle; })).slice(0, 12);
        store(RKEY, list);
      } catch (e) {}
    }
    $$('[data-phd-recent]').forEach(function (sec) {
      var row = $('[data-recent-list]', sec), items = list.filter(function (x) { return x.handle !== currentHandle; });
      if (!items.length) return;
      row.innerHTML = items.map(function (x) {
        return '<a class="phd-mini" href="' + esc(x.url) + '"><img src="' + esc(x.img) + '" alt="" loading="lazy" width="64" height="64"><span><strong>' + esc(x.title) + '</strong><span>' + esc([x.no ? 'No. ' + x.no : '', x.where].filter(Boolean).join(' · ')) + '</span><b>' + esc(x.price) + '</b></span></a>';
      }).join('');
      sec.hidden = false;
      var clr = $('[data-recent-clear]', sec);
      clr && clr.addEventListener('click', function () { store(RKEY, []); sec.hidden = true; });
    });
  }

  /* ---------- sticky add to cart (product page) ---------- */
  function initStickyATC() {
    var btn = $('.template-product [data-add-to-cart]');
    if (!btn || !('IntersectionObserver' in window)) return;
    var item = $('[data-phd-recent-item]'), data = {};
    try { data = JSON.parse(item.textContent); } catch (e) {}
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var bar = document.createElement('div'); bar.className = 'phd-sticky-atc'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = (data.img ? '<img src="' + esc(data.img) + '" alt="">' : '') + '<div class="phd-sticky-atc__txt"><strong>' + esc(data.title || document.title) + (data.no ? ' · No. ' + esc(data.no) : '') + '</strong><span>' + esc(data.price || '') + '</span></div><button type="button" class="phd-btn" tabindex="-1">Add to cart</button>';
    document.body.appendChild(bar);
    $('button', bar).addEventListener('click', function () { btn.click(); bar.classList.remove('is-on'); });
    new IntersectionObserver(function (en) {
      var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
    }).observe(btn);
  }

  /* ---------- newsletter tags ---------- */
  function initNews() {
    $$('[data-news-auction]').forEach(function (cb) {
      var form = cb.closest('form'), tags = form && $('[data-news-tags]', form);
      if (!tags) return;
      function sync() { tags.value = cb.checked ? 'newsletter, auctions' : 'newsletter'; }
      cb.addEventListener('change', sync); sync();
    });
  }

  function boot() {
    initReveal(); initHeader(); initCounters(); initHero(); initTilt(); initSpots();
    initLoupes(); $$('[data-phd-spotlight]').forEach(wireThumbs); initAjaxForms();
    initQuickView(); initExplorer(); initReel(); initLocalities(); initGuide();
    initRecent(); initStickyATC(); initNews();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.PHD = Object.assign(CFG, { quickView: quickView, money: money });
})();
